<template>
  <router-link :to="to" v-slot="{ href, route, navigate, isActive, isExactActive }">
    <li
      v-a11y-tab:tab-line
      :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
    >
      <a :href="href" @click="navigate">{{ label || route.fullPath }}</a>
    </li>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/metrics';
@import '~@/assets/styles/breakpoints';

a {
  color: $text-grey;
  text-decoration: none;
}

.router-link-exact-active,
.router-link-active {
  a {
    color: $primary;
  }
}

@media (max-width: $header-breakpoint) {
  .router-link-active {
    a {
      color: inherit;
    }
  }

  .router-link-exact-active {
    a {
      color: $primary;
    }
  }
}
</style>
